export default "__VITE_ASSET__Jtd62jEq__"